import { Component, OnInit } from '@angular/core';
import { ABCisTableModel, ColumnType } from 'src/app/components/abcis-table/abcis-table.component';
import { ABCisApi } from 'src/app/handlers/apiHandler.service';

@Component({
  selector: 'app-global-product-config',
  standalone: false,
  templateUrl: './global-product-config.component.html',
  styleUrls: ['./global-product-config.component.scss']
})
export class GlobalProductConfigComponent implements OnInit {
  tableConfig: ABCisTableModel;
  constructor() { }

  ngOnInit() {
    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: 'global-product',
        approxamateRowCount: 1000,
        anyParams: true

      },
      colConfig: [
        { field: 'globalSupplierId', header: 'Global Supplier ID', type: ColumnType.MultiSelectComplex, setUrl: 'global-supplier/lookup' , isReadonly: true, isPrimary: true  },
        { field: 'supplierReference', header: 'Supplier Reference', type: ColumnType.String, isReadonly: true, isPrimary: true },
        { field: 'plu', header: 'PLU', type: ColumnType.String },
        { field: 'confidence', header: 'Confidence', type: ColumnType.String },
        { field: 'isLocked', header: 'Is Locked?', type: ColumnType.Boolean },
      ],
      addFormConfig: {
        header: 'Add Globa Product'
      },
      isConfigurable: true
    };
  }
}
